import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { request } from "@/js/http/http_request";
import { paymentState as _paymentState, paymentStates, listUserGroups, orderTypes, orderStatus, getOrderStatusIcon, defaultPagingChoices, expeditionMethods, expeditionMethodList, emptyCellContent, getPublicPaymentStateForAdmins } from "@/js/lists.ts";
import { hasRole } from "@/js/http/auth.js";
import { getOrderConfirmationReference } from "@/js/order/order.js";
import { getSymbolCurrency, formatPrice } from "@/js/currency/currencies.js";
import { getFullNameUserHtml, getFullNameUser, userGroupName } from "@/js/user/user.js";
import { filterVAutocomplete } from "@/js/forms.js";
import { setFilters, getFilters } from "@/js/filter/filter.js";
import pagingComponent from "@/components/paging/PagingComponent.vue";
import indexComponent from "@/components/paging/IndexComponent.vue";
import AdminStandaloneOrderModal from "@/components/order/StandaloneOrders/AdminStandaloneOrderModal.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ImportOrderDialogVue from "@/components/order/ImportOrderDialog.vue";
import ContextMenu from "@/components/context-menu/ContextMenu.vue";
import NewContainerOrderModal from "@/components/order/ContainerOrders/NewContainerOrderModal.vue";
export default {
  name: "AdminOrderList",
  components: {
    Confirm: Confirm,
    ImportOrderDialogVue: ImportOrderDialogVue,
    paging: pagingComponent,
    index: indexComponent,
    AdminStandaloneOrderModal: AdminStandaloneOrderModal,
    NewContainerOrderModal: NewContainerOrderModal,
    ContextMenu: ContextMenu
  },
  props: {
    loggedUserData: Object
  },
  data: function data(_this) {
    return {
      headers: [{
        text: "N°",
        value: "referenceOrder",
        align: "center",
        width: "130px",
        cellClass: "text-nowrap"
      }, {
        text: "Customer",
        value: "customer",
        align: "center",
        width: "200px"
      }, {
        text: "Status",
        value: "status",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "",
        value: "isFullyCalculatedAmounts",
        align: "center"
      }, {
        text: "Amount",
        value: "amount",
        align: "end",
        cellClass: "text-nowrap"
      }, {
        text: "Delivery address",
        value: "deliveryAddress",
        align: "start"
      }, {
        text: "Departure",
        value: "departure",
        align: "center"
      }, {
        text: "Shipping type",
        value: "shipmentMethod",
        align: "start",
        cellClass: "text-nowrap"
      }, {
        text: "Order Date",
        value: "orderDate",
        align: "center"
      }, {
        text: "Delivery Date",
        value: "deliveryDate",
        align: "center"
      }, {
        text: "Due date",
        value: "dueDate",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "Payment",
        value: "payment",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "Consultant",
        value: "consultant",
        align: "center"
      }, {
        text: "Creator",
        value: "creator",
        align: "center"
      }, {
        text: "Salesperson",
        value: "salesman",
        align: "center"
      }],
      isImportOrderShown: false,
      paymentStates: paymentStates,
      listUserGroups: listUserGroups,
      baseModel: {
        orders: [],
        numberOfOrders: 0,
        numberOfPages: 0
      },
      isAdvancedFilterOpened: false,
      formSearch: {
        label: "",
        orderIds: [],
        types: [],
        paymentStates: [],
        status_allowed: [],
        customerIds: [],
        importerIds: [],
        factoringProviderIds: [],
        creatorId: null,
        consultantId: null,
        salesmanId: null,
        isPaymentOverdue: null,
        isPreventInvoice: null,
        isIncludeSubContainerOrders: true,
        departureWarehouseIds: [],
        expeditionMethods: [],
        anyWineIdsIncluded: [],
        excludeWineDetails: true,
        paging: {
          limits: 24,
          currentPage: 0,
          askedPage: 0
        },
        sort_by: null,
        range_date: []
      },
      searchLabelLastUsed: null,
      searchorderIdsLastUsed: [],
      searchTypesLastUsed: [],
      searchPaymentStatesSearchLastUsed: [],
      searchCreatorIdLastUsed: null,
      searchConsultantIdLastUsed: null,
      searchSalesmanIdLastUsed: null,
      searchcustomerIdsLastUsed: [],
      searchImporterIdsLastUsed: [],
      searchFactoringProviderIdsLastUsed: [],
      searchIsPaymentOverdueLastUsed: null,
      searchIsPreventInvoiceLastUsed: null,
      searchDepartureWarehouseIdsIdsLastUsed: null,
      searchExpeditionMethodsLastUsed: null,
      listOrderReference: [],
      isLoadingListOrderReference: false,
      listCreator: [],
      isLoadingListCreator: false,
      listConsultant: [],
      isLoadingListConsultant: false,
      listSalesman: [],
      isLoadingListSalesman: false,
      listCustomer: [],
      isLoadingListCustomer: false,
      listImporter: [],
      isLoadingListImporter: false,
      listFactoringProvider: [],
      isLoadingListFactoringProvider: false,
      listPaymentOverdue: [{
        id: 1,
        label: "Only late payments"
      }],
      listWarehouses: [],
      isLoadingListWarehouse: false,
      listProducts: [],
      isLoadingListProducts: false,
      dataLoading: true,
      pagingLimitsChoices: defaultPagingChoices,
      orderStatus: orderStatus,
      sortBy: [{
        id: "ASCENDING_DATE",
        label: "Ascending date"
      }, {
        id: "DESCENDING_DATE",
        label: "Descending date"
      }, {
        id: "RANGE_DATE",
        label: "Range dates"
      }],
      standaloneOrderModal: {
        shown: false,
        id: null
      },
      newContainerOrderModal: {
        shown: false
      },
      isCopyingToClipboard: false,
      rangeDatesDisplay: [],
      sortByRangeDatesMenu: false,
      orderTypes: orderTypes,
      expeditionMethods: expeditionMethods,
      expeditionMethodList: expeditionMethodList,
      emptyCellContent: emptyCellContent
    };
  },
  computed: {
    isAdvancedFiltering: function isAdvancedFiltering() {
      //sync with created() : this.isAdvancedFilterOpened = true
      return this.formSearch.types.length > 0 || this.formSearch.paymentStates.length > 0 || this.formSearch.importerIds.length > 0 || this.formSearch.factoringProviderIds.length > 0 || this.formSearch.consultantId !== null || this.formSearch.creatorId !== null || this.formSearch.salesmanId !== null || this.formSearch.isPaymentOverdue !== null || this.formSearch.isPreventInvoice !== null || this.formSearch.departureWarehouseIds.length > 0 || this.formSearch.expeditionMethods.length > 0 || this.formSearch.anyWineIdsIncluded.length > 0;
    },
    paymentState: function paymentState() {
      return _paymentState;
    },
    listOrderType: function listOrderType() {
      if (this.canCreateStandaloneOrder) {
        return [{
          id: orderTypes.STANDARD,
          value: "Product"
        }, {
          id: orderTypes.CONTAINER,
          value: "Container"
        }, {
          id: orderTypes.STANDALONE,
          value: "Service"
        }];
      }
      return [];
    },
    filterByOrderStatusAllowed: function filterByOrderStatusAllowed() {
      return orderStatus.filter(function (os) {
        return os.id !== "CREATED";
      });
    },
    isFilteringStatus: function isFilteringStatus() {
      return this.isFilteringToValidate || this.isFilteringToConsolidate || this.isFilteringToShip || this.isFilteringInTransit || this.isFilteringHeld || this.isFilteringDelivered || this.isFilteringInbound || this.isFilteringCancelled;
    },
    isFilteringToValidate: function isFilteringToValidate() {
      var _this$formSearch$stat;
      return (_this$formSearch$stat = this.formSearch.status_allowed) === null || _this$formSearch$stat === void 0 ? void 0 : _this$formSearch$stat.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "ADJUSTING" || x.id == "AWAITING_CUSTOMER_VALIDATION" || x.id == "AWAITING_VALIDATION";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringToConsolidate: function isFilteringToConsolidate() {
      var _this$formSearch$stat2;
      return (_this$formSearch$stat2 = this.formSearch.status_allowed) === null || _this$formSearch$stat2 === void 0 ? void 0 : _this$formSearch$stat2.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "VALIDATED";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringToShip: function isFilteringToShip() {
      var _this$formSearch$stat3;
      return (_this$formSearch$stat3 = this.formSearch.status_allowed) === null || _this$formSearch$stat3 === void 0 ? void 0 : _this$formSearch$stat3.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "IN_PREPARATION";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringInPreparation: function isFilteringInPreparation() {
      var _this$formSearch$stat4;
      return (_this$formSearch$stat4 = this.formSearch.status_allowed) === null || _this$formSearch$stat4 === void 0 ? void 0 : _this$formSearch$stat4.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "VALIDATED" || x.id == "IN_PREPARATION";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringInTransit: function isFilteringInTransit() {
      var _this$formSearch$stat5;
      return (_this$formSearch$stat5 = this.formSearch.status_allowed) === null || _this$formSearch$stat5 === void 0 ? void 0 : _this$formSearch$stat5.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "DELIVERY" || x.id == "CUSTOMS_CLEARANCE" || x.id == "SUBCONTAINER_CONTAINER_IN_TRANSIT";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringHeld: function isFilteringHeld() {
      var _this$formSearch$stat6;
      return (_this$formSearch$stat6 = this.formSearch.status_allowed) === null || _this$formSearch$stat6 === void 0 ? void 0 : _this$formSearch$stat6.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "ON_HOLD";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringDelivered: function isFilteringDelivered() {
      var _this$formSearch$stat7;
      return (_this$formSearch$stat7 = this.formSearch.status_allowed) === null || _this$formSearch$stat7 === void 0 ? void 0 : _this$formSearch$stat7.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "DELIVERED";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringInbound: function isFilteringInbound() {
      var _this$formSearch$stat8;
      return (_this$formSearch$stat8 = this.formSearch.status_allowed) === null || _this$formSearch$stat8 === void 0 ? void 0 : _this$formSearch$stat8.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "INBOUND";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringCancelled: function isFilteringCancelled() {
      var _this$formSearch$stat9;
      return (_this$formSearch$stat9 = this.formSearch.status_allowed) === null || _this$formSearch$stat9 === void 0 ? void 0 : _this$formSearch$stat9.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "CANCELLED";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    canImportOrder: function canImportOrder() {
      return this.$whitelabel.isExportPriceList && hasRole(process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER);
    },
    canCreateStandaloneOrder: function canCreateStandaloneOrder() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_STANDALONE_ORDERS);
    },
    hasResult: function hasResult() {
      return !this.dataLoading && this.baseModel.numberOfOrders > 0;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this2$$route$query, _this2$$route$query3;
      var _this2$$route$query2, _this2$$route$query4, _this2$$route$query5, filters, _this2$formSearch$typ, _this2$formSearch$pay, _this2$formSearch$imp, _this2$formSearch$fac, _this2$formSearch$dep, _this2$formSearch$exp, _this2$formSearch$any;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!((_this2$$route$query = _this2.$route.query) !== null && _this2$$route$query !== void 0 && _this2$$route$query.id_user)) {
              _context.next = 5;
              break;
            }
            _this2.formSearch.customerIds = [+((_this2$$route$query2 = _this2.$route.query) === null || _this2$$route$query2 === void 0 ? void 0 : _this2$$route$query2.id_user)];
            _this2.$router.replace({
              name: _this2.$route.name,
              query: {
                tab: "orders"
              }
            });
            _context.next = 15;
            break;
          case 5:
            if (!((_this2$$route$query3 = _this2.$route.query) !== null && _this2$$route$query3 !== void 0 && _this2$$route$query3.consultantId)) {
              _context.next = 10;
              break;
            }
            _this2.formSearch.consultantId = +((_this2$$route$query4 = _this2.$route.query) === null || _this2$$route$query4 === void 0 ? void 0 : _this2$$route$query4.consultantId);
            _this2.$router.replace({
              name: _this2.$route.name,
              query: {
                tab: "orders"
              }
            });
            _context.next = 15;
            break;
          case 10:
            _context.next = 12;
            return getFilters();
          case 12:
            filters = _context.sent;
            if (filters !== null && filters !== void 0 && filters.orders) {
              _this2.formSearch = _objectSpread(_objectSpread({}, _this2.formSearch), filters.orders);
              if (((_this2$formSearch$typ = _this2.formSearch.types) === null || _this2$formSearch$typ === void 0 ? void 0 : _this2$formSearch$typ.length) > 0 || ((_this2$formSearch$pay = _this2.formSearch.paymentStates) === null || _this2$formSearch$pay === void 0 ? void 0 : _this2$formSearch$pay.length) > 0 || ((_this2$formSearch$imp = _this2.formSearch.importerIds) === null || _this2$formSearch$imp === void 0 ? void 0 : _this2$formSearch$imp.length) > 0 || ((_this2$formSearch$fac = _this2.formSearch.factoringProviderIds) === null || _this2$formSearch$fac === void 0 ? void 0 : _this2$formSearch$fac.length) > 0 || !!_this2.formSearch.consultantId || !!_this2.formSearch.creatorId || !!_this2.formSearch.salesmanId || !!_this2.formSearch.isPaymentOverdue || !!_this2.formSearch.isPreventInvoice || ((_this2$formSearch$dep = _this2.formSearch.departureWarehouseIds) === null || _this2$formSearch$dep === void 0 ? void 0 : _this2$formSearch$dep.length) > 0 || ((_this2$formSearch$exp = _this2.formSearch.expeditionMethods) === null || _this2$formSearch$exp === void 0 ? void 0 : _this2$formSearch$exp.length) > 0 || ((_this2$formSearch$any = _this2.formSearch.anyWineIdsIncluded) === null || _this2$formSearch$any === void 0 ? void 0 : _this2$formSearch$any.length) > 0) {
                _this2.isAdvancedFilterOpened = true;
              }
            }
            if ((_this2$$route$query5 = _this2.$route.query) !== null && _this2$$route$query5 !== void 0 && _this2$$route$query5.is_payment_overdue) {
              _this2.formSearch.isPaymentOverdue = 1;
              _this2.isAdvancedFilterOpened = true;
            }
          case 15:
            _this2.formSearch.label = null;
            if (!_this2.canCreateStandaloneOrder) {
              _this2.resetFilterTypes();
            }
            _this2.getListOrderReferences();
            _this2.getCreatorList();
            _this2.getConsultantList();
            _this2.getSalesmanList();
            _this2.getCustomerList();
            _this2.getImporterList();
            _this2.getFactoringProviderList();
            _this2.getWarehouseList();
            _this2.getProductList();
            _this2.search(true);
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    clearFilters: function clearFilters() {
      this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
        label: "",
        orderIds: [],
        paymentStates: [],
        status_allowed: [],
        customerIds: [],
        importerIds: [],
        factoringProviderIds: [],
        creatorId: null,
        consultantId: null,
        salesmanId: null,
        isPaymentOverdue: null,
        isPreventInvoice: null,
        departureWarehouseIds: [],
        expeditionMethods: [],
        anyWineIdsIncluded: [],
        excludeWineDetails: true,
        paging: {
          limits: 24,
          currentPage: 0,
          askedPage: 0
        },
        sort_by: null,
        range_date: []
      });
      this.resetFilterTypes();
      this.search(true);
    },
    resetFilterTypes: function resetFilterTypes() {
      if (this.canCreateStandaloneOrder) {
        this.formSearch.types = [];
      } else {
        this.formSearch.types = [orderTypes.STANDARD, orderTypes.CONTAINER];
      }
    },
    clearFiltersStatus: function clearFiltersStatus() {
      this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
        status_allowed: []
      });
      this.search(true);
    },
    fillFiltersStatus: function fillFiltersStatus() {
      this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
        status_allowed: this.filterByOrderStatusAllowed.map(function (x) {
          return x.id;
        })
      });
      this.search(true);
    },
    fastFilter: function fastFilter(type) {
      this.formSearch.paging = {
        limits: 24,
        currentPage: 0,
        askedPage: 0
      };
      switch (type) {
        case "to_validate":
          if (this.isFilteringToValidate) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "AWAITING_CUSTOMER_VALIDATION" && id !== "AWAITING_VALIDATION" && id !== "ADJUSTING";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "AWAITING_CUSTOMER_VALIDATION" && id !== "AWAITING_VALIDATION" && id !== "ADJUSTING";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id == "AWAITING_CUSTOMER_VALIDATION" || x.id == "AWAITING_VALIDATION" || x.id == "ADJUSTING";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "to_consolidate":
          if (this.isFilteringToConsolidate) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "VALIDATED";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "VALIDATED";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id === "VALIDATED";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "to_ship":
          if (this.isFilteringToShip) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "IN_PREPARATION";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "IN_PREPARATION";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id === "IN_PREPARATION";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "in_preparation":
          if (this.isFilteringInPreparation) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "VALIDATED" && id !== "IN_PREPARATION";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "VALIDATED" && id !== "IN_PREPARATION";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id == "VALIDATED" || x.id == "IN_PREPARATION";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "held":
          if (this.isFilteringHeld) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "ON_HOLD";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "ON_HOLD";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id === "ON_HOLD";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "in_transit":
          if (this.isFilteringInTransit) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "DELIVERY" && id !== "CUSTOMS_CLEARANCE" && id !== "SUBCONTAINER_CONTAINER_IN_TRANSIT";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "DELIVERY" && id !== "CUSTOMS_CLEARANCE" && id !== "SUBCONTAINER_CONTAINER_IN_TRANSIT";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id == "DELIVERY" || x.id == "CUSTOMS_CLEARANCE" || x.id == "SUBCONTAINER_CONTAINER_IN_TRANSIT";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "delivered":
          if (this.isFilteringDelivered) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "DELIVERED";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "DELIVERED";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id === "DELIVERED";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "inbound":
          if (this.isFilteringInbound) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "INBOUND" && id !== "SUBCONTAINER_PUT_INBOUND";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "INBOUND" && id !== "SUBCONTAINER_PUT_INBOUND";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id === "INBOUND" || x.id === "SUBCONTAINER_PUT_INBOUND";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "cancelled":
          if (this.isFilteringCancelled) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "CANCELLED";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "CANCELLED";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id === "CANCELLED";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
      }
      this.changeFilterBy();
    },
    search: function search() {
      var _this3 = this;
      var isResetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.$EventBus.$emit("loading", true);
      this.dataLoading = true;
      var _this = this;
      if (isResetPaging) _this.resetPaging();
      setFilters(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          orders: _this3.formSearch
        });
      });
      _this.searchLabelLastUsed = _this.formSearch.label;
      _this.searchorderIdsLastUsed = _this.formSearch.orderIds;
      _this.searchTypesLastUsed = _this.formSearch.types;
      _this.searchPaymentStatesSearchLastUsed = _this.formSearch.paymentStates;
      _this.searchcustomerIdsLastUsed = _this.formSearch.customerIds;
      _this.searchImporterIdsLastUsed = _this.formSearch.importerIds;
      _this.searchFactoringProviderIdsLastUsed = _this.formSearch.factoringProviderIds;
      _this.searchCreatorIdLastUsed = _this.formSearch.creatorId;
      _this.searchConsultantIdLastUsed = _this.formSearch.consultantId;
      _this.searchSalesmanIdLastUsed = _this.formSearch.salesmanId;
      _this.searchIsPaymentOverdueLastUsed = _this.formSearch.isPaymentOverdue;
      _this.searchIsPreventInvoiceLastUsed = _this.formSearch.isPreventInvoice;
      _this.searchDepartureWarehouseIdsIdsLastUsed = _this.formSearch.departureWarehouseIds;
      _this.searchExpeditionMethodsLastUsed = _this.formSearch.expeditionMethods;
      _this.searchAnyWineIdsIncludedLastUsed = _this.formSearch.anyWineIdsIncluded;
      return request("/v1/orders", "post", _this.formSearch, true, "api").then(function (response) {
        window.scrollTo({
          top: 0
        });
        _this.baseModel.orders.splice(_this.formSearch.paging.limits);
        _this.baseModel = _objectSpread({}, {
          orders: response.data.orders,
          numberOfOrders: response.data.total_number,
          numberOfPages: Math.ceil(response.data.total_number / _this.formSearch.paging.limits)
        });
        _this.formSearch.paging.currentPage = _this.formSearch.paging.askedPage + 1;
        if (!_this.formSearch.paging.currentPage) {
          _this.formSearch.paging.currentPage = 0;
        }

        //We prepare for row expand
        _this.baseModel.orders = _this.baseModel.orders.map(function (order) {
          return _objectSpread(_objectSpread({}, order), {}, {
            isOrderExpanded: false
          });
        });
        _this.dataLoading = false;
        _this.$EventBus.$emit("loading", false);
      });
    },
    resetPaging: function resetPaging() {
      this.formSearch.paging.askedPage = 0;
    },
    changePage: function changePage(askedPage) {
      if (askedPage >= 0 && askedPage <= this.baseModel.numberOfPages) {
        this.formSearch.paging.askedPage = askedPage;
        this.search();
      }
    },
    changeFilterBy: function changeFilterBy() {
      this.formSearch.paging = {
        limits: 24,
        currentPage: 0,
        askedPage: 0
      };
      this.search(true);
    },
    changeSortBy: function changeSortBy() {
      if (this.sortBy.find(function (x) {
        return x.id === "RANGE_DATE";
      }).id !== this.formSearch.sort_by) {
        this.search(true);
      }
    },
    sortByDatesRanges: function sortByDatesRanges() {
      if (this.formSearch.range_date.length >= 2) {
        this.sortByRangeDatesMenu = false;
        this.search(true);
      }
    },
    clearDateRange: function clearDateRange() {
      this.formSearch.range_date = [];
      this.search(true);
    },
    formatDates: function formatDates() {
      var formatedDates = [];
      this.formSearch.range_date.forEach(function (date) {
        formatedDates.push(new Date(date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        }));
      });
      this.rangeDatesDisplay = formatedDates;
    },
    importOrder: function importOrder() {
      this.isImportOrderShown = true;
    },
    rowClick: function rowClick(order) {
      if (order.type === orderTypes.STANDALONE) {
        this.openStandaloneOrderModal(order.id_order);
      } else {
        var routeData = this.orderDetails(order);
        this.$router.push(routeData);
      }
    },
    rowClickContextMenu: function rowClickContextMenu(mouseEvent, event) {
      mouseEvent.preventDefault();
      if (event.item.type === orderTypes.STANDARD || event.item.type === orderTypes.CONTAINER) {
        var contextItems = [{
          type: "routerLinkBlank",
          text: "Open in a new tab",
          class: "router-link --no-hover-underlined",
          routeData: this.orderDetails(event.item)
        }];
        var position = {
          x: mouseEvent.x,
          y: mouseEvent.y
        };
        this.$refs.contextMenu.openMenu(event.item, contextItems, position);
      }
    },
    isEtaAvailable: function isEtaAvailable(order) {
      return order.expedition_method !== 0 && order.expedition_method !== expeditionMethods.CELLAR_STORAGE.id && order.etaMinHours > 0 && order.etaMaxHours > 0;
    },
    getEtaLabel: function getEtaLabel(eta_min_hours, eta_max_hours) {
      var unit = eta_min_hours > 72 || eta_max_hours && eta_max_hours > 72 ? "days" : "hours";
      if (unit === "days") {
        return Math.ceil(eta_min_hours / 24) + (eta_max_hours ? "-" + Math.ceil(eta_max_hours / 24) : "") + " " + unit;
      } else {
        return eta_min_hours + (eta_max_hours ? "-" + eta_max_hours : "") + " " + unit;
      }
    },
    isPaymentLate: function isPaymentLate(order) {
      var _order$importer, _order$importer2;
      return order.payment_state !== _paymentState.SUCCEEDED && order.payment_state !== _paymentState.FAILED && (!((_order$importer = order.importer) !== null && _order$importer !== void 0 && _order$importer.id) || !order.importer.isPreventingPayment) && new Date(order.dueDate) < new Date() && Date.diffDays(new Date(order.dueDate), new Date()) > 0 || order.payment_state !== _paymentState.SUCCEEDED && order.payment_state !== _paymentState.FAILED && order.importerDueDate && ((_order$importer2 = order.importer) === null || _order$importer2 === void 0 ? void 0 : _order$importer2.id) && order.importer.isPreventingPayment && new Date(order.importerDueDate) < new Date() && Date.diffDays(new Date(order.importerDueDate), new Date()) > 0;
    },
    isPaymentStateLate: function isPaymentStateLate(order) {
      if ((order.user.user_group === "HORECA" || order.user.user_group === "WHOLESALER" || order.user.isHolding) && order.delivery_address.country.iso_2 === "US") {
        return orderStatus.find(function (x) {
          return x.status == order.status;
        }).id === "DELIVERED" && this.isPaymentLate(order);
      } else {
        return (orderStatus.find(function (x) {
          return x.status == order.status;
        }).id === "CUSTOMS_CLEARANCE" || orderStatus.find(function (x) {
          return x.status == order.status;
        }).id === "DELIVERED" || orderStatus.find(function (x) {
          return x.status == order.status;
        }).id === "DELIVERY") && this.isPaymentLate(order);
      }
    },
    hasBeenValidated: function hasBeenValidated(order) {
      return !orderStatus.filter(function (x) {
        return ["AWAITING_CUSTOMER_VALIDATION", "AWAITING_VALIDATION", "ADJUSTING"].includes(x.id);
      }).map(function (x) {
        return x.status;
      }).includes(order.status);
    },
    getOrderStatusClass: function getOrderStatusClass(order) {
      if (orderStatus.find(function (x) {
        return x.status == order.status;
      }).id === "AWAITING_CUSTOMER_VALIDATION" || orderStatus.find(function (x) {
        return x.status == order.status;
      }).id === "AWAITING_VALIDATION" || orderStatus.find(function (x) {
        return x.status == order.status;
      }).id === "ADJUSTING") {
        return "neutral";
      } else if (orderStatus.find(function (x) {
        return x.status == order.status;
      }).id === "ON_HOLD" || orderStatus.find(function (x) {
        return x.status == order.status;
      }).id === "CANCELLED") {
        return "danger";
      } else if (orderStatus.find(function (x) {
        return x.status == order.status;
      }).id === "INBOUND" || orderStatus.find(function (x) {
        return x.status == order.status;
      }).id === "SUBCONTAINER_PUT_INBOUND") {
        return "info";
      } else if (orderStatus.find(function (x) {
        return x.status == order.status;
      }).id === "DELIVERED") {
        return "success";
      }
      return "info";
    },
    getPaymentStateClass: function getPaymentStateClass(order) {
      if (order.payment_state === _paymentState.SUCCEEDED) return "fill-success";
      if (order.payment_state === _paymentState.FAILED) return "fill-danger";
      if (order.payment_state === _paymentState.PROCESSING) return "fill-info";
      return "fill-empty";
    },
    getShipmentMethodIcon: function getShipmentMethodIcon(order) {
      var expeditionMethod = this.expeditionMethodList.filter(function (x) {
        return x.id === order.expedition_method;
      });
      if (expeditionMethod.length) return expeditionMethod[0].faIcon;
    },
    copyToClipboard: function copyToClipboard(text) {
      var _this4 = this;
      this.isCopyingToClipboard = true;
      setTimeout(function () {
        _this4.isCopyingToClipboard = false;
      }, 1000);
      return navigator.clipboard.writeText(text);
    },
    getCreatorList: function getCreatorList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this5.isLoadingListCreator = true;
              _this = _this5;
              data = {
                user_group: ["ADMIN"],
                roles: [process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER],
                include_archive: true
              };
              _context2.next = 5;
              return request("/v1/users", "post", data, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load creator list", {
                  type: "warning"
                });
                _this.isLoadingListCreator = false;
                throw e;
              });
            case 5:
              response = _context2.sent;
              _this5.listCreator = _toConsumableArray(response.data.users);
              _this5.listCreator.sort(function (a, b) {
                if (a.active && !b.active || !a.archive && b.archive) return -1;
                if (!a.active && b.active || a.archive && !b.archive) return 1;
                return a.fullname.localeCompare(b.fullname);
              });
              _this5.listCreator.unshift({
                id_user: 0,
                fullname: "Customer created his order"
              });
              _this5.isLoadingListCreator = false;
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getSalesmanList: function getSalesmanList() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this6.isLoadingListSalesman = true;
              _this = _this6;
              data = {
                user_group: ["ADMIN"],
                roles: [process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER],
                include_archive: true,
                isSalesman: true
              };
              _context3.next = 5;
              return request("/v1/users", "post", data, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load salesman list", {
                  type: "warning"
                });
                _this.isLoadingListSalesman = false;
                throw e;
              });
            case 5:
              response = _context3.sent;
              _this6.listSalesman = _toConsumableArray(response.data.users);
              _this6.listSalesman.sort(function (a, b) {
                if (a.active && !b.active || !a.archive && b.archive) return -1;
                if (!a.active && b.active || a.archive && !b.archive) return 1;
                return a.fullname.localeCompare(b.fullname);
              });
              _this6.listSalesman.unshift({
                id_user: 0,
                fullname: "No salesperson"
              });
              _this6.isLoadingListSalesman = false;
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getConsultantList: function getConsultantList() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this7.isLoadingListConsultant = true;
              _this = _this7;
              data = {
                user_group: ["ADMIN"],
                isConsultantOrHolding: true
              };
              _context4.next = 5;
              return request("/v1/users", "post", data, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load consultant list", {
                  type: "warning"
                });
                _this.isLoadingListConsultant = false;
                throw e;
              });
            case 5:
              response = _context4.sent;
              _this7.listConsultant = _toConsumableArray(response.data.users);
              _this7.listConsultant.sort(function (a, b) {
                if (a.active !== b.active) {
                  return a.active ? -1 : 1;
                }
                return a.fullname.localeCompare(b.fullname);
              });
              _this7.listConsultant.unshift({
                id_user: 0,
                fullname: "No consultant"
              });
              _this7.isLoadingListConsultant = false;
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getCustomerList: function getCustomerList() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this8.isLoadingListCustomer = true;
              _this = _this8;
              data = {
                user_group: ["USER", "HORECA", "WHOLESALER"],
                include_holding: true,
                include_consultant: true,
                include_archive: true
              };
              _context5.next = 5;
              return request("/v1/users", "post", data, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load customer list", {
                  type: "warning"
                });
                _this.isLoadingListCustomer = false;
                throw e;
              });
            case 5:
              response = _context5.sent;
              _this8.listCustomer = _toConsumableArray(response.data.users).map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  labelForList: _this.fullNameUser(x)
                });
              });
              _this8.listCustomer.sort(function (a, b) {
                if (a.active && !b.active || !a.archive && b.archive) return -1;
                if (!a.active && b.active || a.archive && !b.archive) return 1;
                return a.labelForList.localeCompare(b.labelForList);
              });
              _this8.isLoadingListCustomer = false;
            case 9:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    fullNameUser: function fullNameUser(user) {
      var _listUserGroups$find;
      var fullName = getFullNameUser(user) + " - " + (user.delivery_country_iso_code ? user.delivery_country_iso_code : "") + (user.deliveryStateIsoCode ? "-".concat(user.deliveryStateIsoCode) : "") + " " + ((_listUserGroups$find = listUserGroups.find(function (x) {
        return x.id === user.user_group.toUpperCase();
      })) === null || _listUserGroups$find === void 0 ? void 0 : _listUserGroups$find.name) + " (" + user.login + ")";
      var userSuffix = "";
      if (user.archive) {
        userSuffix += " (archived)";
      } else if (!user.active) {
        userSuffix += " (inactive)";
      }
      return fullName + userSuffix;
    },
    openStandaloneOrderModal: function openStandaloneOrderModal() {
      var _this9 = this;
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.standaloneOrderModal.shown = true;
      this.standaloneOrderModal.id = id;
      this.$nextTick(function () {
        _this9.$refs.adminStandaloneOrderModal.open();
      });
    },
    closeStandaloneOrderModal: function closeStandaloneOrderModal() {
      this.standaloneOrderModal.shown = false;
      this.standaloneOrderModal.id = null;
    },
    openNewContainerOrderModal: function openNewContainerOrderModal() {
      var _this10 = this;
      this.newContainerOrderModal.shown = true;
      this.$nextTick(function () {
        _this10.$refs.newContainerOrderModal.open();
      });
    },
    closeNewContainerOrderModal: function closeNewContainerOrderModal() {
      this.newContainerOrderModal.shown = false;
    },
    refreshOrderReferencesAndSearch: function refreshOrderReferencesAndSearch() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this11.getListOrderReferences();
              _this11.search(true);
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    getListOrderReferences: function getListOrderReferences() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this12.isLoadingListOrderReference = true;
              _this = _this12;
              _context7.next = 4;
              return request("/v1/orders/references", "get", {}, true, "api", null).catch(function (e) {
                _this.$toasted.show("Unable to load order references.", {
                  type: "warning"
                });
                _this.isLoadingListOrderReference = false;
                throw e;
              });
            case 4:
              response = _context7.sent;
              _this12.listOrderReference = response.data.value.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  labelForList: x.invoice_number_label ? "".concat(x.reference_order, " - ").concat(x.invoice_number_label) : x.reference_order
                });
              });
              _this12.isLoadingListOrderReference = false;
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    getImporterList: function getImporterList() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this13.isLoadingListImporter = true;
              _this = _this13;
              _context8.next = 4;
              return request("/v1/importers/all", "post", {
                withAvailabilities: true,
                includeDeleted: true
              }, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load importers.", {
                  type: "warning"
                });
                _this.isLoadingListImporter = false;
                throw e;
              });
            case 4:
              response = _context8.sent;
              _this13.listImporter = response.data.value.items;
              _this13.isLoadingListImporter = false;
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    getFactoringProviderList: function getFactoringProviderList() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this14.isLoadingListFactoringProvider = true;
              _this = _this14;
              _context9.next = 4;
              return request("/v1/factoring-providers/all", "post", {
                withAvailabilities: true,
                includeDeleted: true
              }, true, "api", null).catch(function (e) {
                _this.$toasted.show("Unable to load financing options.", {
                  type: "warning"
                });
                _this.isLoadingListFactoringProvider = false;
                throw e;
              });
            case 4:
              response = _context9.sent;
              _this14.listFactoringProvider = response.data.value.items;
              _this14.isLoadingListFactoringProvider = false;
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    getWarehouseList: function getWarehouseList() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this15.isLoadingListWarehouse = true;
              _this = _this15;
              _context10.next = 4;
              return request("/v1/warehouses", "post", {
                paging: null
              }, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load warehouses.", {
                  type: "error"
                });
                _this.isLoadingListWarehouse = false;
                throw e;
              });
            case 4:
              response = _context10.sent;
              _this15.listWarehouses = response.data.warehouses.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  name: x.deleted === true ? "".concat(x.name, " - Deleted") : x.name
                });
              });
              _this15.listWarehouses.sort(function (a, b) {
                if (!a.deleted && b.deleted) return -1;
                if (a.deleted && !b.deleted) return 1;
                return 0;
              });
              _this15.isLoadingListWarehouse = false;
            case 8:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    getProductList: function getProductList() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this16.isLoadingListProducts = true;
              _this = _this16;
              _context11.next = 4;
              return request("/v1/stock?wines=true", "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load products.", {
                  type: "error"
                });
                _this.isLoadingListProducts = false;
                throw e;
              });
            case 4:
              response = _context11.sent;
              _this16.listProducts = _toConsumableArray(response.data.wines.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  display_name: x.display_name + (x.accountancy_code ? " - " + x.accountancy_code : "")
                });
              }));
              _this16.isLoadingListProducts = false;
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    orderDetails: function orderDetails(order) {
      return {
        name: "adminOrderSummary",
        params: {
          id: order.id_order
        }
      };
    },
    getOrderStatusIcon: getOrderStatusIcon,
    getSymbolCurrency: getSymbolCurrency,
    formatPrice: formatPrice,
    userGroupName: userGroupName,
    getFullNameUserHtml: getFullNameUserHtml,
    getOrderConfirmationReference: getOrderConfirmationReference,
    filterVAutocomplete: filterVAutocomplete,
    getPublicPaymentStateForAdmins: getPublicPaymentStateForAdmins
  }
};